import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { Ad6Model } from './model';
import { Ad6ServiceInterface } from './service.interface';

export abstract class Ad6Service<T extends Ad6Model> implements Ad6ServiceInterface<T> {
  protected httpClient = inject(HttpClient);

  constructor(protected endpoint: string) {}

  getList(): Observable<T[]> {
    return this.httpClient.get<T[]>(this.endpoint);
  }

  get(uuid: string): Observable<T> {
    return this.httpClient.get<T>(`${this.endpoint}/${uuid}`);
  }

  create(model: Omit<T, 'uuid'>): Observable<string> {
    return this.httpClient.post<string>(`${this.endpoint}`, model);
  }

  update(model: T): Observable<string> {
    return this.httpClient.put<string>(
      `${this.endpoint}/${model.uuid}`,
      model,
      // TODO Should be solved in the backend
      //  Ensure response is treated as text, because the API returns a string instead of a JSON object
      { responseType: 'text' as 'json' },
    );
  }

  remove(uuid: string): Observable<boolean> {
    return this.httpClient.delete<boolean>(`${this.endpoint}/${uuid}`);
  }
}
